import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Switch,
} from "@mui/material";
import { useState } from "react";
import { Form, useSubmit } from "react-router-dom";
import Section from "./components/Section";

const DistributorStatusSection = ({
  distributor = {}
}) => {
  const [isChecked, setIsChecked] = useState(distributor.active ?? false);
  const submit = useSubmit();

  return (
    <Section title={distributor.name}>
        <Grid item xs={6}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Publisher ID</FormLabel>
            <FormGroup aria-label="position" row>
              {distributor.id}
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Form
            method="post"
            onChange={(e) => submit(e.currentTarget)}
          >
            <FormControl component="fieldset">
              <FormLabel component="legend">3p Programmatic Demmand Enabled</FormLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      name="active"
                      checked={isChecked}
                      onChange={(event) => { setIsChecked(event.target.checked) }}
                      value={"true"}
                    />
                  }
                  label={isChecked ? "On" : "Off"}
                />
              </FormGroup>
            </FormControl>
          </Form>
      </Grid>
    </Section>
  )
}

export default DistributorStatusSection;
